module.exports = __webpack_public_path__ + "img/unlock.3a9147ff.svg";